module.exports = __webpack_public_path__ + "img/touxiangmian@2x.31e29754.png";